<div class="row no-report-pack mt-3">
    <div class="col-12 d-flex flex-column align-items-center justify-content-center text-center">
        <i class="icon-error-report main"></i>
        <h4 class="w-75">Please use the filter icon (<i class="fas fa-filter fa-lg second"></i>) above to select a report pack and generate data.</h4>
    </div>
</div>